import { useEffect, useState } from "react";
import { Row, Col } from "react-grid-system";
import { v4 as uuidv4 } from "uuid";

import styled from "styled-components";
import toast, { Toaster } from "react-hot-toast";

import { IoIosArrowBack } from "react-icons/io";

import { StyledColor } from "../../../interface/index";
import colors from "../../../assets/colors/colors";
import MyDropzone from "./DropZone";
import Loader from "../../utils/Loader";
import { PostUploadImage_API, PutEditRestaurant_API } from "../../../API";
import ConfigCuenta from "./Config-cuenta";
import { uploadFile } from "firebase-config";

import { getDatabase, ref, update, set } from "firebase/database";

interface Props {
  closeModal: () => void;
  data: any;
}

export default function ConfigProfile(props: Props) {
  const [form, setForm] = useState<any>({
    name: "",
    description: "",
    logo: "",
    background: "",
    contact: "",
  });
  const [isLoader, setLoader] = useState<boolean>(false);

  const [complete, setComplete] = useState<any>(false);
  const [newlogo, setNewLogo] = useState<any>(false);
  const [loaderlogo, setLoaderLogo] = useState<any>(false);

  const [completebackground, setCompletePortada] = useState<any>(false);
  const [newPortada, setNewPortada] = useState<any>(false);
  const [loaderPortada, setLoaderPortada] = useState<any>(false);

  useEffect(() => {
    getDataProfile();
  }, []);

  const getDataProfile = () => {
    setLoader(true);

    const data = props.data;

    setForm({
      name: data.name,
      description: data.description,
      logo: data.logo,
      background: data.background,
      location: data.location,
      link_location: data.link_location && data.link_location,
      contact: data.contact,
    });

    setLoader(false);
  };

  const onChange = (e: any) => {
    const value = e.target.value;
    const index = e.target.id;
    form[index] = value;
    setForm({
      ...form,
    });
  };

  const handlePostImage = async (files: any) => {
    try {
      let form_data = new FormData();
      if (files[0]) {
        form_data.append("file", files[0]);
      } else {
        return null;
      }
      const uuidNew = uuidv4();

      const result = await uploadFile(files[0], uuidNew);

      setNewLogo(result);

      toast.success("Logo subido correctamente✅");

      setLoaderLogo(false);
      setComplete(true);
    } catch (error) {
      toast.error("Ha ocurrido un error al subir la imagen.😬");
      setComplete(false);
    }
  };

  const postImageBackground = async (files: any) => {
    setLoaderPortada(true);

    try {
      let form_data = new FormData();
      if (files[0]) {
        form_data.append("file", files[0]);
      } else {
        return null;
      }
      const uuidNew = uuidv4();

      const result = await uploadFile(files[0], uuidNew);

      setNewPortada(result);
      setLoaderPortada(false);
      setCompletePortada(true);
      toast.success("Portada subido correctamente✅");
    } catch (error) {
      toast.error("Ha ocurrido un error al subir la portada.😬");
      setComplete(false);
    }
  };

  const saveData = async () => {
    const db = getDatabase();

    setLoader(true);
    const data = props.data;

    const objectNew = {
      ...form,
      id: data.id,
      logo: newlogo || data.logo,
      background: newPortada || data.background,
    };

    console.log(objectNew, "object newww");

    try {
      const updates: any = {};
      updates["/restaurants/" + props.data.id] = objectNew;

      toast.success("Perfil editado con éxito.");
      setLoader(false);
      return update(ref(db), updates);
    } catch (error) {
      setLoader(false);
      toast.error("Error al editar el perfil.😬:");
    }

    // return;

    // try {
    //   console.log(object, "object");
    //   const updates: any = {};
    //   updates["/restaurants/" + data.id] = object;

    //   console.log(updates, "updates");

    //   toast.success("Perfil editado");
    //   setLoader(false);
    //   return update(ref(db), updates);
    // } catch (error) {
    //   console.log(error, "errror klkl");
    //   toast.error("No se pudo editar el perfil. 😬");
    //   setLoader(false);
    // }
  };

  return (
    <>
      <Content color={colors}>
        <header>
          <Row align="center">
            <Col xs={2} onClick={() => props.closeModal()}>
              <button>
                <IoIosArrowBack />
              </button>
            </Col>
            <Col>
              <h2 className="px-2 pt-1">Configurar cuenta</h2>
            </Col>
          </Row>
        </header>
        <div className="main">
          <div className="create">
            <div className="">
              <label>Portada</label>
              {loaderPortada ? (
                <div className="w-100 text-center">
                  <Loader color="#3498db" />
                  Cargando portada...
                </div>
              ) : (
                <MyDropzone
                  postImage={postImageBackground}
                  image={form.background}
                  new_image={newPortada}
                  complete={completebackground}
                  button_name={"Subir logo"}
                />
              )}
            </div>
            <div className="">
              <label>Logo</label>
              {loaderlogo ? (
                <div className="w-100 text-center">
                  <Loader color="#3498db" />
                  Cargando logo...
                </div>
              ) : (
                <MyDropzone
                  postImage={handlePostImage}
                  image={form.logo}
                  new_image={newlogo}
                  complete={complete}
                  button_name={"Subir logo"}
                />
              )}
            </div>
            <div>
              <label>Nombre</label>
              <input
                type="text"
                placeholder="Nombre"
                className="form-control"
                id="name"
                onChange={onChange}
                value={form.name}
              />
            </div>
            <div>
              <label>WhatsApp</label>
              <input
                type="text"
                placeholder="WhatsApp"
                className="form-control"
                id="contact"
                onChange={onChange}
                value={form.contact}
              />
            </div>
            <div>
              <label>Ubicación </label>
              <textarea
                placeholder="Ubicación"
                className="form-control"
                id="location"
                onChange={onChange}
                value={form.location}
              ></textarea>
            </div>
            {/* <div>
                            <label>Link Ubicación Google Maps </label>
                            <textarea
                                placeholder="Google Maps"
                                className="form-control"
                                id="link_location"
                                onChange={onChange}
                                value={form.link_location}
                            ></textarea>
                        </div> */}
            <div>
              <label>Descripción </label>
              <textarea
                placeholder="Descripción"
                className="form-control"
                id="description"
                onChange={onChange}
                value={form.description}
              ></textarea>
            </div>
          </div>
        </div>
        {/* <ConfigCuenta /> */}

        {!isLoader && (
          <>
            <hr />
            <div className="w-100 my-4 pb-4 text-center">
              <div className="row align-items-center justify-content-center">
                <div className="col-4">
                  <button
                    className="btn btn-secondary d-block w-100"
                    onClick={() => props.closeModal()}
                  >
                    Cancelar
                  </button>
                </div>
                <div className="col-4">
                  <button
                    className="btn btn-success d-block w-100"
                    onClick={() => saveData()}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        {isLoader && (
          <div className="w-100 text-center">
            <Loader color="#3498db" />
          </div>
        )}

        <Toaster position="bottom-center" reverseOrder={false} />
      </Content>
    </>
  );
}

const Content = styled.div<StyledColor>`
  width: 100%;
  height: 100vh;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  overflow-x: hidden !important;
  overflow-y: scroll;
  padding-bottom: 5em;
  header {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 10000;
    padding: 1em 0;
    background: white;
    border-bottom: 1px solid #ecf0f1;
    color: #2c3e50;
    button {
      border: none;
      background: white;
      padding: 0.8em 1em;
      box-shadow: 0px 0px 10px #0000012f;
      border-radius: 6px;
      color: #2c3e50;
      svg {
        font-size: 1.5em;
        margin-top: -5px;
      }
    }
  }
  .main {
    width: 100%;
    min-height: 10vh;
    padding: 1em;
    margin-top: 5em;
    .create {
      div {
        padding: 0.5em;
      }
    }
  }

  label {
    font-size: 1.3em;
    font-weight: bold !important;
  }
  input,
  textarea {
    display: block;
    font-size: 1em;
    border: 2px solid ${(props) => props.color.white01};
    &:focus {
      border: 2px solid ${(props) => props.color.blue};
    }
  }
`;
